import './GuardianOfZone.css';

export default function HiperstitionGuardian() {
  return (
    <svg className="guardian-svg guardian-hiperstition" viewBox="0 0 100 150" role="img">
      <title>Hiperstición — El Mago del Vacío, levitando entre anillos orbitales</title>
      <ellipse cx="50" cy="70" rx="46" ry="16" fill="none" className="g-stroke-a g-spin-a" style={{ transformOrigin: '50px 70px' }} strokeWidth="1" opacity="0.35" />
      <ellipse cx="50" cy="55" rx="30" ry="42" fill="none" className="g-stroke-b g-spin-b" style={{ transformOrigin: '50px 55px' }} strokeWidth="1" opacity="0.3" />
      <g className="g-sway-a" style={{ transformOrigin: '50px 60px' }} opacity="0.62">
        <path d="M50 10 C40 10 34 20 36 32 C37 40 42 46 46 50 C40 70 38 100 44 132 L50 138 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.3" />
        <path d="M36 32 C30 45 25 60 28 75" fill="none" className="g-stroke-a" strokeWidth="4" strokeLinecap="round" />
      </g>
      <g className="g-sway-b" style={{ transformOrigin: '50px 60px' }} opacity="0.62">
        <path d="M50 10 C60 10 66 20 64 32 C63 40 58 46 54 50 C60 70 62 100 56 132 L50 138 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.3" />
        <path d="M64 32 C70 45 75 60 72 75" fill="none" className="g-stroke-b" strokeWidth="4" strokeLinecap="round" />
      </g>
      <ellipse cx="50" cy="26" rx="7" ry="8" className="g-cutout" />
      <ellipse cx="47" cy="25.5" rx="1.5" ry="1.8" className="g-fill-core" />
      <ellipse cx="53" cy="25.5" rx="1.5" ry="1.8" className="g-fill-core" />
      <path d="M48 29 Q50 30.5 52 29" fill="none" className="g-stroke-core" strokeWidth="1" strokeLinecap="round" />
      <ellipse cx="50" cy="146" rx="14" ry="3" className="g-fill-a" opacity="0.18" />
    </svg>
  );
}
